import React, { useEffect } from "react";
import { useState, useContext } from "react";
import * as request from "superagent";
import { Dialog, DialogContent, DialogActions, Button } from "@mui/material";
import { makeStyles, Theme, createStyles } from "@mui/styles";
// import LoadingView from '~common/components/loading-view';
import DefinitionSection from "~common/form/definition-section-fc";
import {
  DataContext,
  PolicyContext,
  DirtyContext,
} from "~common/form/icg-definition-data-provider";
import Renderers from '~common/lib/renderers';
import {Definition} from '~common/lib/types';
// import { cloneDeep } from "lodash";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    taskCard: {
        width: '100%',
        background: theme.palette.background.paper,
        border: '1px solid #ccc',
        minHeight: 200
      },
      caption: {
        textAlign: 'center',
        borderBottom: '1px solid #ccc',
        padding: 10
      },
      cardContent: {
        margin: '10px 15px 10px 15px'
      },
      countContent: {
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        minHeight: 120,
        fontSize: '3.0rem',
        cursor: 'pointer'
      },
      templateContent: {
        minHeight: 120
      },
      cardContentEven: {
        margin: '10px 15px 10px 15px',
        display: 'flex',
        justifyContent: 'space-around'
      },
      cardActions: {
        padding: 5
      }
  })
);

var countForm: any = new Definition({
    key: 'countForm',
    title: 'Count Form',
    predefined: [
      {
        gridAttributes: {
          lg: 12,
          md: 12,
          newRow: true,
          sm: 12,
          xl: 12,
          xs: 12
        },
        key: 'title',
        mode: 'Required',
        title: 'Card Title',
        type: 'Text'
      },
      {
        gridAttributes: {
          lg: 12,
          md: 12,
          sm: 12,
          xl: 12,
          xs: 12
        },
        key: 'elementType',
        mode: 'Hidden',
        defaultValue: 'Count',
        options: [
          {
            label: 'Count',
            value: 'Count'
          },
          {
            label: 'Template',
            value: 'Template'
          },
          {
            label: 'Form',
            value: 'Form'
          },
          {
            label: 'Chart',
            value: 'Chart'
          }
          // {
          //   "label": "List",
          //   "value": "List"
          // }
        ],
        title: 'Card Type',
        type: 'Text'
      },
      {
        conditionalAttributes: [
          {
            attributeName: 'mode',
            attributeValue: 'Required',
            operator: '==',
            path: 'elementType',
            value: 'Template'
          }
        ],
        gridAttributes: {
          lg: 12,
          md: 12,
          newRow: true,
          sm: 12,
          xl: 12,
          xs: 12
        },
        key: 'template',
        mode: 'Hidden',
        title: 'Template',
        type: 'Text',
        variant: 'TextArea'
      },
      {
        conditionalAttributes: [
          {
            attributeName: 'mode',
            attributeValue: 'Required',
            operator: '==',
            path: 'elementType',
            value: 'Chart'
          }
        ],
        gridAttributes: {
          lg: 12,
          md: 12,
          newRow: true,
          sm: 12,
          xl: 12,
          xs: 12
        },
        key: 'categoryAttribute',
        mode: 'Hidden',
        title: 'Category Attribute',
        type: 'Text'
      }
    ],
    user: [],
    definitions: []
  });

interface CountEditorProps  {
    element: any;
    onConfigChange: Function;
}
export  const CountEditor: React.FC<CountEditorProps> = ({
    element,
    onConfigChange
}) => {
    const _classes = useStyles()
    
    
    const [fullData, setFullData] = useContext(DataContext);

    useEffect(()=>{
        onConfigChange(fullData)
    }, [fullData])
    
    return (
        <DefinitionSection
            key={"countEditor"}
            suppressTitle={true}
            definition={countForm}
            path={""}
            gridSpacing={8}
            preventCollapse={true}
            suppressSectionStatusIcon={true}
        />
    )
}

CountEditor.register = () => {
    if (!Renderers.find("CountConfigRenderer")) {
        Renderers.register("CountConfigRenderer", CountEditor);
    }
}

export default CountEditor;



